export { default } from "./Playfair4xlRegular";
